import * as React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { CampaignsEmptyState, NoResult } from 'ui/illustrations';
import { spacing, colors } from 'ui/theme';
import { body1, heading4 } from 'ui/theme/typography';
import { Link } from 'ui/links';

const EmptyStateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${pxToRem(400)};
`;

const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${pxToRem(461)};
`;

const MainStyling = styled.div`
  margin-bottom: ${spacing.half};
  ${heading4};
`;

const CaptionStyling = styled.div`
  text-align: center;
  ${body1};
  color: ${colors.textSecondary};
`;

type ImageProps = {
  height?: number;
  width?: number;
};
interface EmptyStateGeneratorProps {
  Image: React.ComponentType<React.PropsWithChildren<ImageProps>>;
  mainText: string;
  id: string;
  children: React.ReactNode;
}

const EmptyStateGenerator = ({ Image, mainText, id, children }: EmptyStateGeneratorProps) => (
  <EmptyStateWrapper data-test={id}>
    <EmptyStateContent>
      <Image />
      <MainStyling>{mainText}</MainStyling>
      <CaptionStyling>{children}</CaptionStyling>
    </EmptyStateContent>
  </EmptyStateWrapper>
);

export const GeneralEmptyState = (): JSX.Element => (
  <EmptyStateGenerator
    Image={CampaignsEmptyState}
    mainText="No campaigns yet"
    id="campaign-index-empty-state"
  >
    <div>
      Message and engage your contacts across various channels.
      <br />
      Learn more by visiting our{' '}
      <Link size="body1" href={'https://support.iterable.com/'}>
        Knowledge Center
      </Link>
      .
    </div>
  </EmptyStateGenerator>
);

export const NoResults = (): JSX.Element => (
  <EmptyStateGenerator
    Image={NoResult}
    mainText="No matching results"
    id="campaign-index-no-results"
  >
    {'Try adjusting your filters or searching by different keywords.'}
  </EmptyStateGenerator>
);
